import React from "react"
import Layout from "../../../common/layout/layout"
import SEO from "../../../common/seo/seo"
import BlogPreview from "./blogPreview/components/BlogPreview"
import { graphql } from "gatsby"

const BlogPreviewTemplate = ({ pageContext, data }) => {
  const postDescription = pageContext.postIntro.content[0].content.find(
    item => item.value
  )
  // let maxLength = 255
  // let trimmedString = postDescription.value.substring(0, maxLength)
  return (
    <Layout>
      <SEO title={pageContext.metaTitle ? pageContext.metaTitle : ""} description={pageContext.metaDescription ? pageContext.metaDescription : ""} />
      <BlogPreview
        microDataDescription={postDescription.value}
        pageTitle={pageContext.title}
        allBlogs={data.allBlogs.edges}
        blogs={data.allContentfulPosts.edges}
        favicon={data.faviconLogo.edges}
      />
    </Layout>
  )
}

export default BlogPreviewTemplate

export const pageQuery = graphql`
  query ContentfulBlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    faviconLogo: allFile(filter: { relativeDirectory: { eq: "faviconLogo" } }) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 300, quality: 100) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }
    allBlogs: allContentfulPosts(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          slug
          title
          timeToRead
          intro {
            content {
              nodeType
              content {
                value
              }
            }
          }
          categories {
            slug
            name
          }
          mainImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          largeImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          date(formatString: "DD-MM ")
          author {
            id
            name
            slug
            email
            avatar {
              fluid(maxWidth: 200) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }

    allContentfulPosts(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          id
          title
          slug
          categories {
            name
          }
          date(formatString: "DD-MM-YYYY")
          timeToRead
          mainImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          largeImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          internalLink {
            slug
          }
          content {
            id
            json
          }
          tags {
            tagName
          }
          confirmedBy {
            name
            avatar {
              fluid(maxWidth: 200) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
          author {
            id
            name
            slug
            email
            bio {
              content {
                content {
                  value
                }
              }
            }
            avatar {
              fluid(maxWidth: 200) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
  }
`
